<template>
  <div class="px-0 mx-5 mb-16">
    <v-overlay :value="overlayReceiver">
        <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <div class="row">
      <div class="col-md-12">
        <v-stepper v-model="step">
            <v-stepper-header style="background: #50c995;">
                <v-stepper-step :complete="step > 1" step="1" complete-icon="mdi-check-all" color="#2d7456">
                    <b class="white--text">DATOS DE FACTURACIÓN</b>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2" complete-icon="mdi-check-all" color="#2d7456">
                    <b class="white--text"> DATOS DE ENVÍO</b>                    
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" step="3" complete-icon="mdi-check-all" color="#2d7456">
                    <b class="white--text"> DATOS DE PAGO</b>   
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1" class="px-3 px-xs-0">
                    <v-row>
                        <v-col cols="12" md="6" class="offset-md-3">
                            <v-form ref="form_billing_data" class="form_billing_data">  
                                <v-card class="mx-auto">
                                    <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                        <b>
                                            <v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-file-document</v-icon> SUS DATOS DE FACTURACIÓN (Requerido *)
                                        </b>
                                    </div>          
                                    <v-col>
                                        <div class="mt-7">
                                            <v-select
                                                v-model="deliveryType"
                                                :items="deliveryTypes"
                                                item-value="type"
                                                item-text="name"
                                                :prepend-inner-icon=iconTypeDelivey
                                                label="Tipo de entrega"
                                                dense
                                                outlined
                                                @change="changeDeliveryType"
                                            ></v-select>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-text-field
                                                    v-model="identification"
                                                    :rules="validIdentification"
                                                    outlined
                                                    dense
                                                    rounded
                                                    append-icon="mdi mdi-magnify"
                                                    @click:append="searchClient"
                                                    @keyup.enter="searchClient"
                                                >
                                                <template v-slot:label>
                                                    <span class="gray--text font-title">
                                                    <i>Identificación *</i></span>
                                                </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <div >
                                                    <v-select
                                                        v-model="identificationType"
                                                        :items="identificationTypes"
                                                        item-value="name"
                                                        item-text="name"
                                                        dense
                                                        outlined
                                                    >
                                                        <template v-slot:label>
                                                            <span class="gray--text font-title">
                                                                <i>Tipo de identificación *</i>
                                                            </span>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" class="pt-0">
                                                <v-text-field
                                                    v-model="firstName"
                                                    :rules="validName"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                        <i>Nombres *</i>
                                                    </span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0">
                                                <v-text-field
                                                    v-model="lastName"
                                                    :rules="validName"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                <template v-slot:label>
                                                    <span class="gray--text font-title">
                                                    <i>Apellidos *</i></span
                                                    >
                                                </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0">
                                                <v-text-field
                                                    type="email"
                                                    v-model="email"
                                                    :rules="ruleEmail"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                <template v-slot:label>
                                                    <span class="gray--text font-title">
                                                        <i>Email *</i>
                                                    </span >
                                                </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0">
                                                <v-autocomplete
                                                    v-model=contactMechIdPhone
                                                    :items=phones
                                                    item-value='contact_mech_id'
                                                    item-text='phone'
                                                    dense
                                                    rounded
                                                    outlined
                                                    append-outer-icon="mdi mdi-plus-circle"
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    @click:append-outer="addPhone('client')"
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Teléfono *</i>
                                                        </span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row> 
                                        <v-btn 
                                            v-if="identification!=null"
                                            color="primary" 
                                            block 
                                            @click="validDatashipping"
                                            :loading=loadingBtn
                                        > 
                                            <b> <v-icon>mdi-arrow-right-bold-circle</v-icon> SIGUIENTE </b>
                                        </v-btn>   
                                        <v-btn 
                                            v-else
                                            color="primary" 
                                            block 
                                            @click="validDatashipping"
                                            :loading=loadingBtn
                                        > 
                                            <b> <v-icon>mdi-content-save</v-icon> GUARDAR DATOS DEL CLIENTE </b>
                                        </v-btn>   
                                    </v-col>   
                                </v-card>                              
                            </v-form>   
                        </v-col>
                    </v-row> 
                </v-stepper-content>
                <v-stepper-content step="2" class="px-3 px-xs-0">
                   <v-btn 
                        color="warning" 
                        block
                        @click="step = 1"
                    > 
                        <v-icon>mdi mdi-arrow-left-bold-circle</v-icon> DATOS DE FACTURACIÓN
                    </v-btn>
                    <v-form ref="form_new_purchase">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-form ref="form_receiver_data" class="form_receiver_data">    
                                    <v-card class="mx-auto" :style="`height: ${newPersonReceiving ? '673px' : '424px'}`">
                                        <div class='white--text text-md-subtitle-1 py-2 px-2 primary d-flex align-center justify-space-between'>
                                            <b>
                                                <v-icon class='white--text' style="position: relative;top: -3px;">mdi mdi-account-star</v-icon> 
                                                PERSONA QUE RECIBE EL PEDIDO (Requerido *)
                                            </b>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn 
                                                        rounded 
                                                        fab 
                                                        x-small 
                                                        class="warning"
                                                        v-bind="attrs" 
                                                        v-on="on"
                                                        @click="setPersonReceiving"
                                                    > 
                                                        <v-icon>mdi-account-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Nueva persona</span>
                                            </v-tooltip>
                                        </div>  
                                        <v-row>
                                            <v-col cols="12" :class="newPersonReceiving ? 'mt-1' : 'mt-9'">
                                                <v-select
                                                    v-model="personReceiver"
                                                    :items="persons"
                                                    item-value="party_id"
                                                    item-text="name"
                                                    dense
                                                    rounded
                                                    outlined
                                                    @change="setDataPerson"
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Personas</i>
                                                        </span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" class="pt-0">
                                                <v-text-field
                                                    v-model="firstNameReceiver"
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                <template v-slot:label>
                                                    <span class="gray--text font-title">
                                                        <i>Nombres *</i>
                                                    </span>
                                                </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pt-0">
                                                <v-text-field
                                                    v-model="lastNameReceiver"
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Apellidos *</i>
                                                        </span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col 
                                                cols="12" 
                                                class="pt-0"
                                                v-if="showDirectionsPerson"
                                            >
                                                <v-select
                                                    v-model="directionReceiver"
                                                    :items="directionsClient"
                                                    item-value="contact_mech_id"
                                                    item-text="direction"
                                                    dense
                                                    outlined
                                                    rounded
                                                    @change="setDirectionInputs"
                                                
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Sus direcciones</i>
                                                        </span>
                                                    </template>
                                                    <template v-slot:append-outer>
                                                        <v-btn
                                                            rounded
                                                            color="primary"
                                                            class="py-4"
                                                            style="position: relative;bottom:8px;margin-right: 5px;"
                                                            @click="dialogNewDirection=true"
                                                        >
                                                           <v-icon>mdi mdi-plus-circle</v-icon> Nueva <span v-if="['md','lg','xl'].includes($vuetify.breakpoint.name)"> dirección </span>
                                                        </v-btn>
                                                    </template> 
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0" v-show="newPersonReceiving">
                                                <v-select
                                                    v-model="provinceReceiver"
                                                    :items="provinces"
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    item-value="geo_id"
                                                    item-text="geo_name"
                                                    dense
                                                    rounded
                                                    outlined
                                                    @change="getDataAutocomplete(`${provinceReceiver}/parroquias-provincia`,'states')"
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Provincia *</i>
                                                        </span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0" v-show="newPersonReceiving">
                                                <v-autocomplete
                                                    v-model=cityReceiver
                                                    :items=states
                                                    item-value='cityReceiver.parroquia_id'
                                                    item-text='parroquia'
                                                    dense
                                                    rounded
                                                    outlined
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    return-object
                                                    @change="getDataAutocomplete(`${cityReceiver.canton_id}/sectores-canton`,'sector')"
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Ciudad *</i>
                                                        </span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0" v-show="newPersonReceiving">
                                                <v-autocomplete
                                                    v-if=autoCompleteSector
                                                    v-model=sectorReceiver
                                                    :items=sectors
                                                    item-value='id'
                                                    item-text='nombre'
                                                    dense
                                                    rounded
                                                    outlined
                                                    label='Seleccione el sector'
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                ></v-autocomplete>
                                                <v-text-field
                                                    v-else
                                                    v-model=sectorReceiver
                                                    dense
                                                    rounded
                                                    outlined
                                                    label='Escriba el sector'
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0" v-show="newPersonReceiving">
                                                <v-text-field
                                                    v-model="street1Receiver"
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Calle princial *</i>
                                                        </span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="pt-0" v-show="newPersonReceiving">
                                                <v-text-field
                                                    v-model="street2Receiver"
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    outlined
                                                    dense
                                                    rounded
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Calle secundaria *</i>
                                                        </span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>    
                                            <v-col cols="12" sm="6" class="pt-0" v-show="newPersonReceiving">
                                                <v-autocomplete
                                                    v-if="!newPersonReceiving"
                                                    v-model=contactMechIdPhoneReceiver
                                                    :items=phonesReceiver
                                                    item-value='contact_mech_id'
                                                    item-text='phone'
                                                    dense
                                                    append-outer-icon="mdi mdi-plus-circle"
                                                    rounded
                                                    outlined
                                                    :rules="deliveryType =='delivery' ? ruleRequire : []"
                                                    @click:append-outer="addPhone('receiver')"
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title">
                                                            <i>Teléfono *</i>
                                                        </span>
                                                    </template>
                                                </v-autocomplete>
                                                <v-text-field
                                                    v-else
                                                    type="number"
                                                    v-model=phoneNewPerson
                                                    dense
                                                    rounded
                                                    outlined
                                                    label='Escriba el telefono'
                                                    :rules=ruleRequire
                                                    class="mx-2"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pt-0" v-show="newPersonReceiving">
                                                <v-textarea 
                                                    outlined 
                                                    rounded 
                                                    v-model="referenceReceiver" 
                                                    rows="2"
                                                    :rules="deliveryType == 'delivery' ? ruleRequire : []"
                                                >
                                                    <template v-slot:label>
                                                        <span class="gray--text font-title"><i>Refrencias</i></span>
                                                    </template>
                                                </v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-form>  
                            </v-col>
                            <v-btn 
                                color="primary" 
                                block
                                v-if="['xs','sm'].includes($vuetify.breakpoint.name)"
                                @click="showhideMap"
                            > 
                                <v-icon>mdi mdi-{{showMap ? 'eye-off' : 'eye'}}</v-icon> {{showMap ? 'OCULTAR' : 'VER'}} MAPA
                            </v-btn>
                            <v-col 
                                cols="12" 
                                md="6" 
                                v-show="['md','lg','xl'].includes($vuetify.breakpoint.name) || showMap"
                            >
                                <v-card class="mx-auto">
                                    <v-col v-if="deliveryType =='delivery'" >
                                        <v-row>
                                            <l-map 
                                                ref="myMap"
                                                :style="`height: ${newPersonReceiving ? '673px' : '400px'}`" 
                                                :zoom="zoom" 
                                                :center="center"
                                                @click="onMapClick"
                                            >
                                                <l-tile-layer :url="urlMap" attribution="Grupo Innofarm"></l-tile-layer>
                                                <l-marker
                                                    ref="marker"
                                                    :draggable=true
                                                    :update:visible=true
                                                    :lat-lng="maker.latLng"
                                                    @dragend="onDragEnd"
                                                >
                                                    <l-tooltip :options="{ permanent: true, interactive: true }">
                                                        <div> <b>DIRECCIÓN:</b> </div>
                                                        <div> {{maker.label}} </div>
                                                    </l-tooltip>
                                                </l-marker>
                                            </l-map>
                                        </v-row>
                                    </v-col>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    color="primary" 
                                    block 
                                    @click="dataPerson"
                                    :loading=loadingBtn2
                                > 
                                    <b> <v-icon>mdi-content-save</v-icon> IR AL PAGO </b>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-stepper-content>
                <v-stepper-content step="3" class="px-3 px-xs-0">
                    <v-btn color="warning" block @click="step = 2"> 
                        <v-icon>mdi mdi-arrow-left-bold-circle</v-icon> DATOS DE ENVÍO
                    </v-btn>
                    <v-row>
                        <v-col cols="12" md="5">
                            <v-card class="mx-auto">
                                <div class='gray--text text-md-subtitle-1 primary py-2 px-2'>
                                    <b class="white--text">
                                        <v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-cart-outline</v-icon> SUS PRODUCTOS
                                    </b>
                                </div>
                                <div v-if="shoppingCar.length">
                                    <div v-for="(sc, x) in shoppingCar"
                                        :key="x"
                                        style="border: 2px solid silver; border-radius: 10px"
                                        class="my-2"
                                    >
                                        <div class="ml-6 mt-2"><b>{{sc.internal_name}} </b></div>
                                        <v-col class="d-flex align-center flex-column flex-sm-row pt-0">
                                            <v-col class="text-caption text-md-body-2"  style="flex:0 0 65%">
                                                <b> Disponibles: {{ sc.inventory }} </b>
                                                <br />
                                                <b>Cantidad: {{sc.quantity}}</b>
                                                <br />
                                                <b>Precio: ${{sc.price}} c/u</b>
                                                <span v-if="sc.valor_descuento">
                                                <br  />
                                                <b>Desc. promoción: ${{sc.valor_descuento.toFixed(2)}} c/u</b>
                                                <br />
                                                <b>Precio con descuento: ${{(sc.price-sc.valor_descuento).toFixed(2)}} c/u</b>
                                                </span>
                                            </v-col>
                                            <v-col class="text-center px-0" style="flex:0 0 25%" v-if="sc.is_promo == '0'">
                                                <div 
                                                    style='border:2px solid #50c995;width:100%' class="rounded-xl text-caption text-center"
                                                    v-if="fetching && sc.is_promo == '0'"
                                                >
                                                    <v-progress-circular
                                                        indeterminate
                                                        color="primary"
                                                        :size="20"
                                                    />
                                                </div>
                                                <div
                                                    style="border: 2px solid #50c995"
                                                    class="rounded-xl text-caption"
                                                    v-if="!fetching && sc.is_promo == '0'"
                                                >
                                                    <v-icon
                                                        class="primary--text px-2"
                                                        @click="quantity('-', sc)"
                                                    >
                                                        mdi-minus mdi-18px
                                                    </v-icon>
                                                    <span class="font-weight-bold gray--text"><b>{{sc.quantity}}</b></span>
                                                    <v-icon
                                                        class="primary--text px-2"
                                                        @click="quantity('+', sc)"
                                                    >
                                                        mdi-plus mdi-18px
                                                    </v-icon>
                                                </div>
                                            </v-col>
                                            <v-col 
                                                class="text-center px-0"
                                                v-if="sc.is_promo == '0'"
                                                style="flex:0 0 10%"
                                            >
                                                <v-btn icon @click="removeItemShopping(sc)">
                                                    <v-icon class="red--text">mdi-delete-forever</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <div v-if="sc.is_promo" class="text-center">
                                                <b class="primary--text"> 
                                                    <v-icon class="primary--text" style="position: relative;bottom: 2px;">mdi-sale</v-icon> PROMOCIÓN 
                                                </b>
                                            </div>
                                        </v-col>
                                        <v-col v-if="sc.psicotropico" class="py-0">
                                            <img 
                                                src="../../../../assets/psicotropicos.png"
                                                style="width:30px"
                                            > <span style="position: relative;bottom: 8px;">Producto psicotropico (Requiere receta médica)</span> 
                                        </v-col>
                                    </div>
                                </div>
                                <div v-else class="text-md-h6 gray--text">
                                    <v-icon>mdi-alert-circle</v-icon> Sin productos agregados
                                </div>
                            </v-card>
                            <v-row v-if="menuMovil && paymentType =='electronic_transfer'">
                                <v-col>
                                    <v-btn 
                                        v-if="this.shoppingCar.length"
                                        color="success" 
                                        block
                                        class="px-5"
                                        @click="continueQuote(null)"
                                    >
                                        <v-icon class="mr-2">mdi mdi-cash-multiple</v-icon> PAGAR
                                    </v-btn>
                                    <v-alert
                                        v-else
                                        border="right"
                                        colored-border
                                        type="error"
                                        elevation="2"
                                    >
                                        DEBE SELECCIONAR AL MENOS 1 PRODUCTO
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="7">
                            <v-card class="mx-auto">
                                <div v-if="!menuMovil">
                                    <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                        <b><v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-cash-multiple</v-icon>TOTALES</b>
                                    </div>
                                    <v-col class="py-0">
                                        <v-row>
                                            <v-col xs="6" class="pb-0"><b>SUBTOTAL</b></v-col>
                                            <v-col xs="6" class="text-right pb-0"><b>${{this.subTotal.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col xs="6" class="py-0"><b>IVA</b></v-col>
                                            <v-col xs="6" class="text-right py-0"><b>${{this.taxes.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row v-if="deliveryType=='delivery'">
                                            <v-col xs="6" class="py-0"><b>ENVÍO</b></v-col>
                                            <v-col xs="6" class="text-right py-0"><b>${{this.priceShipment.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col xs="6" class="pt-0"><b>TOTAL</b></v-col>
                                            <v-col xs="6" class="text-right pt-0"><b>${{this.total.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-text-field
                                                v-model="coupon"
                                                class="mx-2"
                                                label="Cupón de descuento"
                                                placeholder="Ingese un cupón de descuento"
                                                outlined
                                                :error-messages="errorsCoupon"
                                                :error="errorCoupon"
                                                :messages=successCoupon
                                                :success="succCoupon"
                                                persistent-hint
                                                dense
                                                @keyup.enter="applyCoupons"
                                            >
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon 
                                                                color="success"
                                                                v-bind="attrs" 
                                                                v-on="on"
                                                                @click="applyCoupons"
                                                            >
                                                                mdi-tag-plus
                                                            </v-icon>
                                                        </template>
                                                        Aplicar cupón de descuento
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </div>
                                <div v-else>
                                    <div class='white--text text-md-subtitle-1 py-2 mt-6 px-2 primary'>
                                        <b>
                                            <v-icon class="white--text" style="position: relative;top: -3px;">mdi-cash-multiple</v-icon> 
                                            TOTALES
                                        </b>
                                    </div>
                                    <v-col class="py-0">
                                        <v-row>
                                            <v-col xs="6" class="pb-0"><b>SUBTOTAL</b></v-col>
                                            <v-col xs="6" class="text-right pb-0"><b>${{this.subTotal.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col xs="6" class="py-0"><b>IVA</b></v-col>
                                            <v-col xs="6" class="text-right py-0"><b>${{this.taxes.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row v-if="deliveryType=='delivery'">
                                            <v-col xs="6" class="py-0"><b>ENVÍO</b></v-col>
                                            <v-col xs="6" class="text-right py-0"><b>${{this.priceShipment.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col xs="6" class="pt-0"><b>TOTAL</b></v-col>
                                            <v-col xs="6" class="text-right pt-0"><b>${{this.total.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col xs="6" class="pt-0"><b>TOTAL</b></v-col>
                                            <v-col xs="6" class="text-right pt-0"><b>${{this.total.toFixed(2)}}</b></v-col>
                                        </v-row>
                                        <v-row>
                                            <v-text-field
                                                v-model="coupon"
                                                class="mx-2"
                                                label="Cupón de descuento"
                                                placeholder="Ingese un cupón de descuento"
                                                outlined
                                                :error-messages="errorsCoupon"
                                                :error="errorCoupon"
                                                :messages=successCoupon
                                                :success="succCoupon"
                                                persistent-hint
                                                dense
                                                @keyup.enter="applyCoupons"
                                            >
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon 
                                                                color="success"
                                                                v-bind="attrs" 
                                                                v-on="on"
                                                                @click="applyCoupons"
                                                            >
                                                                mdi-tag-plus
                                                            </v-icon>
                                                        </template>
                                                        Aplicar cupón de descuento
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </div>
                                <v-form ref="form_new_purchase">
                                    <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                        <b><v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-cash-multiple</v-icon> FORMAS DE PAGO</b>
                                    </div>
                                    <v-radio-group
                                        v-model="paymentType"
                                        column
                                        class="ml-3"
                                        hide-details
                                    >
                                        <v-radio value="tdc-td">
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <b> <v-icon>mdi mdi-credit-card</v-icon> TARJETA DE CRÉDITO / DÉBITO</b>
                                                </span>
                                            </template>
                                        </v-radio>
                                        <v-radio value="electronic_transfer">
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <b><v-icon>mdi mdi-transfer</v-icon> TRANSFERENCIA ELECTRÓNICA</b>
                                                </span>
                                            </template>
                                        </v-radio>
                                    </v-radio-group>
                                
                                    <div v-if="paymentType=='electronic_transfer'" class="mt-3">
                                        <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                            <b>
                                                <v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-bank</v-icon> 
                                                CUENTA BANCARIA
                                            </b>
                                        </div>
                                        <div class="mt-3">
                                            <v-select
                                                v-model="bankSelected"
                                                :items="bankAccountsData"
                                                item-value="fin_account_id"
                                                item-text="fin_account_name"
                                                prepend-inner-icon="mdi-format-list-bulleted"
                                                label="Bancos disponibles"
                                                dense
                                                outlined
                                                class="px-3"
                                                :hide-details=true                                                
                                                @change="changeBankAccount"
                                            ></v-select>
                                        </div>
                                        <ul>
                                            <li> <b>Número:</b> {{numberAccountBank}}</li>
                                            <li> <b>Titular:</b>{{ownerAccountBank}}</li>
                                            <li> <b>Identificación:</b> {{identificationAccountBank}}</li>
                                            <li> <b>Correo:</b> {{emailAccountBank}}</li>                                                
                                        </ul>
                                        <div class="px-3 mt-2">
                                            <v-text-field
                                                v-model="referenceEftAccount"
                                                outlined
                                                dense
                                                label="DIGÍTE LA REFERENCIA DE LA TRANSFERENCIA AQUÍ"
                                                :rules=ruleRequire
                                                class=""
                                            ></v-text-field>
                                        </div>
                                        <v-col 
                                            v-if="shoppingCar.filter(e => e.psicotropico).length"
                                            class="px-3"
                                        >
                                            <div 
                                                v-if="shoppingCar.filter(e => e.psicotropico).length"
                                                class='white--text text-md-subtitle-1 pt-2 px-2 mb-2 primary '
                                            >
                                                <b>
                                                    <img 
                                                        src="../../../../assets/psicotropicos.png"
                                                        style="width:30px"
                                                    >
                                                    <span style="position: relative;bottom: 8px;left:3px">
                                                        El pedido necesita la receta de los productos psicotropicos
                                                    </span> 
                                                </b>
                                            </div>
                                            <v-file-input
                                                label="Cargue aquí los archivos de la(s) receta(s)"
                                                outlined
                                                multiple
                                                :rules=ruleRequire
                                                dense
                                                accept=".png,.jpg"
                                                prepend-inner-icon="mdi-file-image"
                                                prepend-icon=""
                                                @change="setFile($event)"
                                            ></v-file-input>    
                                        </v-col>
                                        <v-row v-if="!menuMovil">
                                            <v-col>
                                                <v-btn 
                                                    v-if="this.shoppingCar.length"
                                                    color="success" 
                                                    block
                                                    class="px-5"
                                                    @click="continueQuote(null)"
                                                >
                                                    <v-icon class="mr-2">mdi mdi-cash-multiple</v-icon> PAGAR
                                                </v-btn>
                                                <v-alert
                                                    v-else
                                                    border="right"
                                                    colored-border
                                                    type="error"
                                                    elevation="2"
                                                >
                                                    DEBE SELECCIONAR AL MENOS 1 PRODUCTO
                                                </v-alert>                                                   
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-else class="mt-3">
                                        <div v-if="shoppingCar.filter(e => e.psicotropico).length">
                                            <div class='white--text text-md-subtitle-1 pt-2 px-2 mb-2 primary text-left'>
                                                <b>
                                                    <img 
                                                        src="../../../../assets/psicotropicos.png"
                                                        style="width:30px"
                                                    >
                                                    <span style="position: relative;bottom: 8px;left:3px">
                                                        El pedido necesita la receta de los productos psicotropicos
                                                    </span> 
                                                </b>
                                            </div>
                                            <v-file-input
                                                label="Cargue aquí los archivos de la(s) receta(s)"
                                                outlined
                                                multiple
                                                :rules=ruleRequire
                                                dense
                                                accept=".png,.jpg"
                                                prepend-inner-icon="mdi-file-image"
                                                prepend-icon=""
                                                @change="setFile($event)"
                                            ></v-file-input>
                                        </div>
                                        <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                            <b>
                                                <v-icon class="white--text" style="position: relative;top: -3px;">mdi-cash-multiple</v-icon> 
                                                HACER EL PAGO CON PLACETOPAY
                                            </b>
                                        </div>
                                        <div  v-if="this.shoppingCar.length" class="text-center">
                                            <v-checkbox
                                                v-model="termAndConditions"
                                                :rules=ruleRequire
                                                append-icon="append-icon"
                                            >
                                                <template v-slot:label>
                                                    <div>
                                                    <b>
                                                        Aceptar términos y condiciones y políticas de protección de datos personales
                                                        <a target="_blank" href="/terminos-y-condiciones" @click.stop>
                                                            (LEER)
                                                        </a>
                                                    </b>
                                                </div>
                                                </template>
                                            </v-checkbox>
                                            <img 
                                                src="https://static.placetopay.com/placetopay-logo.svg"
                                                style="width:80%;margin:0 auto;"                                                    
                                            >
                                            <img 
                                                src="../../../../assets/tarjetas-credito-logos.png"
                                                style="width:40%;margin:0 auto;"
                                            >
                                            <v-btn 
                                                color="success" 
                                                block
                                                class="px-5"
                                                @click="goToPlaceToPay"
                                            >
                                                <v-icon class="mr-2">mdi mdi-cash-multiple</v-icon> PAGAR
                                            </v-btn>
                                        </div>
                                        <v-alert
                                            v-else
                                            border="right"
                                            colored-border
                                            type="error"
                                            elevation="2"
                                        >
                                            DEBE SELECCIONAR AL MENOS 1 PRODUCTO
                                        </v-alert>
                                    </div>
                                </v-form>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      </div>
    </div>
    <v-dialog 
        v-model="dialogNewDirection" 
        max-width="1000px"
        persistent
    >   
        <div style="background: white;">
            <CaptureDirection 
                @close="dialogNewDirection= false" 
                @storeDirection="storeDirection" 
            />
        </div>
    </v-dialog>
    <v-dialog 
        v-model="dialogNewPhone" 
        max-width="600px"
        persistent
    >   
        <div style="background: white;">
            <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                <b>
                    <v-icon class="white--text" style="position: relative;top: -3px;">mdi-cellphone</v-icon> 
                    INGRESE EL NUEVO TELÉFONO
                </b>
            </div>  
            <v-form ref="form_new_phone" class="my-3">
                <v-text-field-simplemask
                    v-model="newPhone"
                    label="Escriba el telefono"
                    class="mx-2"
                    :properties="{
                        prefix: '',
                        suffix: '',
                        readonly: false,
                        disabled: false,
                        outlined: false,
                        clearable: true,
                        placeholder: '(000) 000-00-00',
                        rules: ruleRequire
                    }"
                    :options="{
                        inputMask: '(###) ###-##-##',
                        outputMask: '###########',
                        empty: null,
                        applyAfter: false,
                        alphanumeric: false,
                        lowerCase: false,
                    }"
              
                />
                <v-col cols="12" class="text-center" >           
                    <v-btn
                        color="primary" 
                        @click="storeNewPhone"
                    > 
                        <b> <v-icon>mdi-content-save</v-icon> GUARDAR </b>
                    </v-btn>
                    <v-btn color="default" class="mx-2" @click=closePhoneDialog>
                        <v-icon>mdi-cancel</v-icon> Cerrar
                    </v-btn>
                </v-col>
            </v-form>
        </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl } from 'vue2-leaflet'
import Geohash from "latlon-geohash"
import { GoogleProvider } from 'leaflet-geosearch'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
import { latLng } from "leaflet"
import axios from "axios";
import Vue from "vue";
import CaptureDirection from '../partials/CaptureDirectionComponent.vue'
import moment from 'moment'
import sha1 from 'sha1'

export default {
    metaInfo: {
        script: [
            { src: 'https://checkout.placetopay.ec/lightbox.min.js', async: true, defer: true },  
        ],
    },
    name: "ProdcutsCheckoutComponent",
    components:{
        CaptureDirection,
        LMap,
        LTileLayer,
        LMarker,
        LPopup, 
        LTooltip,
        LControl
    },
    data: () => ({
        showMap:false,
        ruleRequire: [(v) => !!v || "El campo es obligatorio"],
        ruleEmail:[
            v => !!v || 'Debe escribir un correo electrónico',
            v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Debe escribir un correo válido'
        ],
        breadcrumb: { 
            name: "Servicio", 
            url: "servicios" 
        },
        selectProduct: {
            product_id: null,
            quantity: 0,
            product_name: "",
        },
        deliveryTypes:[
            {type: 'delivery', name:'ENTREGA A DOMICILIO'},
            {type: 'pickup', name: 'RETIRAR EN TIENDA'}
        ],
        maker:{
            latLng: [0,0],
            label: 'Dirección'
        },
        objGeoCoding: {
            provider: new GoogleProvider({
                apiKey: 'AIzaSyAqaUSU9oq2u3S7LstJG7oT_o0_u-BLrFE',
                language: 'es',
                region:'ec'
            }),
        },
        zoom: 13,
        center: latLng(0, 0),
        urlMap: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        contactMechIdEmailClient:null,
        partyIdClient: null,
        identification:null,
        firstName: null,
        lastName: null,
        email: null,
        tlf: null,
        fetching:false,
        referenceEftAccount:null,
        accessKeyPlaceToPay:null,
        loginPlaceToPay:null,
        endPointPlaceToPay:null,
        deliveryType:'delivery',
        iconTypeDelivey: 'mdi mdi-truck',
        paymentMethodTypeId:'PLACE_TO_PAY_CC',
        dialogNewDirection:false,
        overlayReceiver:false,
        dialogNewPhone:false,
        dialogNewMail:false,
        termAndConditions:false,
        firstNameReceiver: null,
        lastNameReceiver: null,
        emailReceiver: null,
        sectorReceiver:null,
        street1Receiver:null,
        street2Receiver:null,
        provinceReceiver:null,
        directionReceiver:null,
        cityReceiver:null,
        contactMechIdPhoneReceiver:null,
        address: null,
        city: null,
        statusPaymentPlaceToPay:'PENDING',
        requestIdPlaceToPay :null,
        referenceReceiver: null,
        step: 1,
        newPersonReceiving:false,
        identificationType:null,
        bankSelected:null,
        ownerAccountBank:null,
        emailAccountBank:null,
        identificationAccountBank:null,
        numberAccountBank:null,
        personReceiver:null,
        contactMechIdPhone:null,
        newPhone:null,
        autoCompleteSector: true,
        partyIdPhone:null,
        phoneNewPerson:null,
        showDirectionsPerson:true,
        subTotal:0,
        taxes:0,
        total:0,
        subTotalWithImp:0,
        priceShipment:0,
        shipmentMethodId: 'NO_SHIPPING',
        carrierPartyId:null,
        coupon:null,
        errorCoupon:false,
        errorsCoupon:null,
        succCoupon:false,
        successCoupon:null,
        personPhone:'client',
        paymentType:'tdc-td',
        directionsClient:[],
        bankAccountsData:[],
        provinces:[],
        phonesReceiver:[],
        shippingMethods:[],
        phones:[],
        persons:[{
            party_id: null,
            name: 'SELECCIONE'
        }],
        states:[],
        sectors:[],
        identificationTypes:[
            {name:'CEDULA'},
            {name: 'PASAPORTE'},
            {name: 'RUC'}
        ],
        files: [],
    }),
    watch:{

        personReceiver (val){
            this.showDirectionsPerson = val !='' && val != null 
        },

        paymentType(val){
            this.paymentMethodTypeId = val == 'electronic_transfer' ? 'EFT_ACCOUNT' : 'PLACE_TO_PAY_CC'
        }
        
    },
    computed: {

        menuMovil() {
            return this.$vuetify.breakpoint.name == "sm" ||this.$vuetify.breakpoint.name == "xs"
        },

        ...mapState([
            "shoppingCar",
            "token",
            "url",
            "directoryFileQuote",
            "urlApi",
            "pathFileProducts",
            "user",
            "loadingBtn",
            "loadingBtn2",
            "selectedProducts"
        ]),

        validIdentification(){

            return[
                (v) => {
                    if(!v){
                        return 'La identificación es obligatoria' 
                    }else if(this.identificationType == 'CEDULA' && v.length != 10){
                        return 'La identificación débe tener 10 carácteres' 
                    }else if(this.identificationType == 'RUC' && v.length != 13){
                        return 'La identificación débe tener 13 carácteres' 
                    }else if(this.identificationType == 'PASAPORTE' && (v.length < 4 || v.length > 16)){
                        return 'La identificación débe entre 4 y 16 carácteres'             
                    }else if(isNaN(v) && this.identificationType != 'RUC'){
                        return 'La identificación débe ser de sólo números'
                    }else{
                        return true
                    }
                }
            ]

    	},

        validName(){

            return[
                (v) => {
                    if(this.identificationType == 'RUC' && !v){
                        return true
                    }else if(!v){
                        return 'El campo es obligatorio' 
                    }else if(v == '' || v.trim().length == 0){
                        return 'La campo es obligatorio' 
                    }else if(this.identificationType != 'RUC' && !(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g.test(v.trim()))){
                        return 'Los campo deben tener sólo letras'
                    }else{
                        return true
                    }
                }
            ]

        },

    },
    methods: {

        ...mapMutations([
            "setCheckout",
            "setTotalQuantity",
            "itemShoppingCar",
            "setLoadingTable",
            "setUrl",
            "setLoadingBtn",
            "setLoadingBtn2",
            "deleteSelectedProducts",
            "setSelectedProducts"
        ]),

        ...mapActions(["alertNotification","requestApi","updateQuoteItems"]),

        setFile(file) {
            this.files = file;
        },

        continueQuote(referencePaymentId) {

            if (!this.$refs.form_new_purchase.validate()) 
                return

            this.overlayReceiver = true

            //let arr = [];
            let quoteId = localStorage.getItem('quote_id')

            //ACTUALIZA COTIZACION, CREA EL ORDER Y RESERVA LA MERCADERIA
            this.setUrl('completar-cotizacion-ecommerce')
   
            let formData = new FormData()
            formData.append("partyId", this.partyIdClient)
            formData.append("contactMechDirectionId", this.directionReceiver)
            formData.append("contactMechPhoneId", this.contactMechIdPhone)
            formData.append("contactMechEmailId", this.contactMechIdEmailClient)
            formData.append("paymentMethodTypeId", this.paymentMethodTypeId)
            formData.append("shipmentMethodTypeId", this.shipmentMethodId)
            formData.append("partyIdReceiver", this.personReceiver)
            formData.append("shipmmentAmount",this.priceShipment)
            formData.append("carrierPartyId",this.carrierPartyId)
            formData.append("deliveryType",this.deliveryType)
            formData.append("contactMechDirectionIdLat",this.maker.latLng[0])
            formData.append("contactMechDirectionIdLng",this.maker.latLng[1])
            formData.append("labelDirection",this.maker.label)
            formData.append("statusPaymentPlaceToPay",this.statusPaymentPlaceToPay)
            formData.append("requestIdPlaceToPay",this.requestIdPlaceToPay)
            formData.append("user", this.user.user_ligin_id)
            formData.append("payment_method_type_id", this.paymentMethodTypeId)
            formData.append("manual_ref_num", referencePaymentId != null ? referencePaymentId : this.referenceEftAccount)
            formData.append("max_amount", this.total.toFixed(2))
            formData.append("payment_method_id",null)
            formData.append("tenantId",process.env.VUE_APP_TENANT)
            formData.append("quoteId",quoteId)

            this.files.forEach((data,x) => {
               formData.append(x, data);
            })
            
            axios.post(this.url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + this.token,
                },
            }).then(res => {
         
                if(this.paymentMethodTypeId == 'EFT_ACCOUNT'){

                    const { msg } = res.data.detail
                    
                    Vue.swal({
                        title: msg,
                        html: "Le responderemos en breve.",
                        icon: "success",
                        confirmButtonColor: "#50c995",
                        toast: false,
                        grow: false,
                        position: "center",
                        confirmButtonText: "Cerrar",
                    })

                    setTimeout(()=>{ this.$router.push('/') },5000)   

                    this.deleteShoppingCar()

                }

                this.firstName = null
                this.lastName = null
                this.email = null
                this.tlf = null
                this.address = null
                this.city = null
                this.reference = null
                this.files = []

            }).catch(err => {
                console.log(err)
                this.overlayReceiver =false
                Vue.swal({
                    title: "Error!",
                    html: err.data.detail,
                    icon: "error",
                    confirmButtonColor: "#d60400",
                    toast: false,
                    grow: false,
                    position: "center",
                    confirmButtonText: "Cerrar",
                })

            }).then(() => {

                this.overlayReceiver =false

            })

        },

        quantity(operator, product) {

            let products = this.shoppingCar;
            let itemExist = products.find((e) => e.product_id == product.product_id);

            if (typeof itemExist != "undefined") {

                this.fetching = this.$store.getters.getIsLoggedIn  

                let index = products.indexOf(itemExist)

                if (operator == "+") {
                    
                    if(products[index].quantity <= product.inventory-1)
                        products[index].quantity += 1

                } else {

                    if(products[index].quantity > 1)
                        products[index].quantity -= 1
                    
                }

                this.itemShoppingCar(products)

                this.updateQuoteItems({
                    action:'modify',
                    cantidad: products[index].quantity,
                    productId : product.product_id,
                    quoteId: localStorage.getItem('quote_id')
                }).then(res =>{

                    this.deleteSelectedProducts()
              
                    res.data.detail.quoteItems.forEach(item => {
                    
                        this.setSelectedProducts({
                            product_id: item.product_id,
                            images: item.images,
                            price: parseFloat(item.price),
                            quantity: parseFloat(item.quantity),
                            brand_name : item.brand_name,
                            internal_name : item.internal_name,
                            tax_value : parseFloat(item.tax_value),
                            psicotropico: item.psicotropico,
                            quoteItemSeqId: item.quote_item_seq_id,
                            inventory: item.inventory,
                            valor_descuento: isNaN(parseFloat(item.valor_descuento)) ? 0 : parseFloat(item.valor_descuento),
                            is_promo: isNaN(parseFloat(item.is_promo)) ? 0 : parseFloat(item.is_promo), 
                        })

                    })  

                    this.itemShoppingCar(this.selectedProducts)

                    this.fetching=false
                    
                    this.calculateTotals()

                })

            }

        },

        removeItemShopping(product) {

            let products = this.shoppingCar;
            let obj = products.find(e => e.product_id == product.product_id)

            if (typeof obj != "undefined") {

                let index = products.indexOf(obj)
                products.splice(index, 1)
                this.itemShoppingCar(products)
         
                this.updateQuoteItems({
                    action:'delete',
                    quoteId: localStorage.getItem('quote_id')
                })
                .then(res =>{

                    this.deleteSelectedProducts()

                    res.data.detail.quoteItems.forEach(item => {
                        
                        this.setSelectedProducts({
                            product_id: item.product_id,
                            images: item.images,
                            price: parseFloat(item.price),
                            quantity: parseFloat(item.quantity),
                            brand_name : item.brand_name,
                            internal_name : item.internal_name,
                            tax_value : parseFloat(item.tax_value),
                            psicotropico: item.psicotropico,
                            quoteItemSeqId: item.quote_item_seq_id,
                            inventory: item.inventory,
                            valor_descuento: isNaN(parseFloat(item.valor_descuento)) ? 0 : parseFloat(item.valor_descuento),
                            is_promo: isNaN(parseFloat(item.is_promo)) ? 0 : parseFloat(item.is_promo)
                        })

                    })  

                    this.itemShoppingCar(this.selectedProducts)

                    this.calculateTotals()

                })
                
            }else{

                this.calculateTotals()

            }

        },

        searchClient(){

            this.setUrl(`buscar-cliente/${this.identification}`);
            this.overlayReceiver=true

            this.requestApi({
                method: 'GET',
                data: {
                    partyId : this.user.party_id
                }
            }).then(async res=>{
               
                this.newPersonReceiving=false

                if(res.data.person != null){

                    const {
                        party_id,
                        first_name,
                        last_name, 
                        email, 
                        phones, 
                        directions, 
                        relationships,
                        party_identification_type_id,
                    } = res.data.person
                   
                    this.firstName = first_name
                    this.lastName = last_name
                    this.email = email != null ? email.info_string : ''
                    this.contactMechIdEmailClient = email != null ? email.contact_mech_id : ''
                    this.phonesReceiver = phones
                    this.phones = phones
                    this.contactMechIdPhoneReceiver = phones.length ? phones[0].contact_mech_id : null
                    this.contactMechIdPhone = phones.length ? phones[0].contact_mech_id : null
                    this.directionsClient = directions
                    this.identificationType = party_identification_type_id
                    this.partyIdClient = party_id
                    this.firstNameReceiver = first_name
                    this.lastNameReceiver = last_name
                    
                    this.persons.push({
                        party_id:this.user.party_id,
                        name: this.user.name
                    })

                    this.personReceiver = this.user.party_id
                    this.setDataPerson()
                    
                    for(let relation of relationships)
                        this.persons.push(relation)
                    
                    if(directions.length){
                        
                        this.provinceReceiver= directions[0].geo_id

                        await this.getDataAutocomplete(`${this.provinceReceiver}/parroquias-provincia`,'states')
                        this.cityReceiver = directions[0].city

                        let objState = this.states.find(e => e.parroquia == this.cityReceiver)

                        if(typeof objState != 'undefined'){
                            await this.getDataAutocomplete(`${this.states.find(e => e.parroquia == this.cityReceiver).canton_id}/sectores-canton`,'sector')
                            this.sectorReceiver= parseInt(directions[0].sector)
                        }

                        this.directionReceiver = directions[0].contact_mech_id
                        this.referenceReceiver = directions[0].observaciones
                        this.street1Receiver= directions[0].address1
                        this.street2Receiver= directions[0].calle_secundaria
                        console.log('directions[0].direction',directions[0])

                        if(directions[0].latitude != null && directions[0].longitude != null){

                            this.center = latLng(directions[0].latitude,directions[0].longitude)
                            this.maker.latLng = [directions[0].latitude,directions[0].longitude]
                            this.maker.label = directions[0].direction

                            this.zoom=20

                            this.selectShippingMethod()

                        }else{

                            this.objGeoCoding.provider.search({query:`${directions[0].direction}`})
                            .then(res => {
                                
                                if(typeof res[0] != 'undefined'){
                                    this.center = latLng(res[0].y,res[0].x)
                                    this.maker.latLng = [res[0].y,res[0].x]
                                    this.maker.label = directions[0].direction
                                }
                                this.zoom=20

                                this.selectShippingMethod()
                            })


                        }

                        
                       
                    }

                }else{

                    this.contactMechIdEmailClient= null
                    this.partyIdClient= null
                    this.firstName= null
                    this.lastName= null
                    this.email= null
                    this.tlf= null
                    this.identificationType = null

                    this.alertNotification({
                        param:{
                            html : 'Identificación no encontrada, por favor ingrese su datos en los campos requeridos para continuar con la compra',
                            timer: 5000,
                            title: 'Error',
                            icon: 'error',
                            confirmButtonColor: 'red'
                        }
                    })
                    
                }

                this.overlayReceiver=false
            })

        },

        async setDirectionInputs(){
            
            
            let objDirection = this.directionsClient.find(e => e.contact_mech_id == this.directionReceiver)

            if(typeof objDirection != 'undefined'){

                this.directionReceiver = objDirection.contact_mech_id
                this.referenceReceiver = objDirection.observaciones
                
                this.street1Receiver= objDirection.address1
                this.street2Receiver= objDirection.calle_secundaria
                this.provinceReceiver= objDirection.geo_id
                await this.getDataAutocomplete(`${this.provinceReceiver}/parroquias-provincia`,'states')
                this.cityReceiver = objDirection.city
                await this.getDataAutocomplete(`${this.states.find(e => e.parroquia == this.cityReceiver).canton_id}/sectores-canton`,'sector')
                this.sectorReceiver= isNaN(parseInt(objDirection.sector)) ? objDirection.sector :  parseInt(objDirection.sector)
              
                if(objDirection.latitude != null && objDirection.longitude != null){

                    this.center = latLng(objDirection.latitude,objDirection.longitude)
                    this.maker.latLng = [objDirection.latitude,objDirection.longitude]
                    this.maker.label = objDirection.direction

                    this.zoom=20

                    this.selectShippingMethod()

                }else{

                    this.objGeoCoding.provider.search({query: objDirection.direction })
                    .then(res => {
                        
                        if(typeof res[0] != 'undefined'){
                            this.center = latLng(res[0].y,res[0].x)
                            this.maker.latLng = [res[0].y,res[0].x]
                            this.maker.label = objDirection.direction
                        }
                        this.zoom=20

                        this.selectShippingMethod()
                    })


                }


               

            }

        },

        validDatashipping(){

            if(!this.$refs.form_billing_data.validate())
                return false
           
            this.step= 2
 
            this.$nextTick(() => {
                this.$refs.myMap.mapObject.invalidateSize()            
            })
               
            this.setLoadingBtn()

            this.setUrl(`buscar-cliente`);
            
            this.requestApi({
                method: 'PATCH',
                data: {
                    data:{
                        partyId: this.partyIdClient,  
                        firstName: this.firstName,
                        lastName: this.lastName,
                        identification: this.identification,
                        identificationType: this.identificationType,
                        email: this.email,
                        contactMechIdEmailClient: this.contactMechIdEmailClient
                    }
                }
            }).then(async res=>{

                this.setUrl(`cotizacion/${localStorage.getItem('quote_id')}/email`);
            
                this.requestApi({
                    method: 'PATCH',
                    data:{
                        contactMechIdEmail: this.contactMechIdEmailClient,
                        tenantId: process.env.VUE_APP_TENANT
                    }
                })

                this.setUrl(`cotizacion/${localStorage.getItem('quote_id')}/telefono`);
            
                this.requestApi({
                    method: 'PATCH',
                    data:{
                        contactMechIdTelefono: this.contactMechIdPhone,
                        tenantId: process.env.VUE_APP_TENANT
                    }
                })

                this.partyIdClient = res.data.detail.partyIdclient

                let validate = (this.deliveryType == 'delivery' && this.$refs.form_receiver_data.validate()) || this.deliveryType == 'pickup'

                this.alertNotification({
                    param:{
                        html : `${validate ? res.data.detail.msg : 'Debe guardar todos los datos de la persona que recibe el pedido'}`,
                        title: validate ? 'Exito' : 'Error',
                        icon: validate ? 'success' : 'error',
                        confirmButtonColor: validate ? 'rgb(165, 220, 134)' : 'red'
                    }
                })

                this.setLoadingBtn()
                this.selectShippingMethod()

            })

        },

        getBankAccountData(){

            this.setUrl('busqueda-catalogo/1')
            this.requestApi({
                method: 'PUT',
                data :{}
            }).then(res =>{
                
                this.bankAccountsData = res.data.cuentas
                this.loginPlaceToPay = res.data.dataPlaceToPay.login_place_to_pay
                this.accessKeyPlaceToPay = res.data.dataPlaceToPay.access_key_place_to_pay
                this.endPointPlaceToPay = res.data.dataPlaceToPay.url_place_to_pay
                this.shippingMethods = res.data.shippingMethods

                if(this.bankAccountsData.length){
                    this.bankSelected= this.bankAccountsData[0].fin_account_id
                    this.changeBankAccount()
                }

            })

        },

        changeBankAccount(){

            let objBankAccount = this.bankAccountsData.find(e => e.fin_account_id == this.bankSelected)

            const { account_number, owner, owner_identification, owner_mail } = objBankAccount

            this.ownerAccountBank=owner
            this.emailAccountBank= owner_mail
            this.identificationAccountBank= owner_identification
            this.numberAccountBank= account_number

        },

        newDirection(){

            this.dialogNewDirection = true
        },

        storeDirection(data){

            this.setUrl('user-login/'+this.personReceiver)
         
            this.requestApi({
                method: 'PUT',
                data:{
                    firstNameReceiver: this.firstNameReceiver,
                    lastNameReceiver: this.lastNameReceiver,
                    province: data.province,
                    parroquiaIdReceiver: data.state.parroquia_id,
                    provinciaId: data.state.provincia_id,
                    cantonId: data.state.canton_id,
                    street: data.street,
                    street2: data.secondaryStreet,
                    sectorReceiver: data.sector,
                    reference: data.reference,
                    city: data.state.parroquia
                }
            }).then(res => {

                this.dialogNewDirection=false
                this.directionsClient.push({
                    address1: res.data.detail.address1,
                    calle_secundaria: res.data.detail.calle_secundaria,
                    city: res.data.detail.city,
                    contact_mech_id: res.data.detail.contact_mech_id,
                    geo_id: res.data.detail.geo_id,
                    observaciones: res.data.detail.reference,
                    sector: res.data.detail.sector,
                    direction: res.data.detail.direction,
                })

                let dir = this.directionsClient.find(e => e.contact_mech_id == res.data.detail.contact_mech_id)
                this.directionReceiver = dir.contact_mech_id
                this.setDirectionInputs()

            })

        },

        setPersonReceiving(){

            this.personReceiver = null
            this.newPersonReceiving=true
            this.firstNameReceiver= null 
            this.lastNameReceiver= null 
            this.emailReceiver= null 
            this.sectorReceiver= null 
            this.street1Receiver= null 
            this.street2Receiver= null 
            this.provinceReceiver= null 
            this.directionReceiver= null 
            this.cityReceiver= null 
            this.referenceReceiver= null 
            this.directionsClient =[]

        },

        dataPerson(){

            /*if(!this.$refs.form_billing_data.validate())
                return false*/
            if (this.deliveryType == 'delivery'){

                if(this.$refs.form_receiver_data.validate())
                    this.step= 3

            }else{

                this.step= 3

            }
     
            this.setLoadingBtn2()

            this.setUrl('buscar-cliente')
            let quoteId = localStorage.getItem('quote_id')
            
            this.requestApi({
                method: 'POST',
                data:{
                    partyId: this.user.party_id,
                    personPartyId: this.personReceiver,
                    contactMechIdDirection: this.directionReceiver,
                    contactMechIdPhone: this.contactMechIdPhoneReceiver,
                    newPersonReceiving: this.newPersonReceiving,
                    firstNameReceiver: this.firstNameReceiver,
                    lastNameReceiver: this.lastNameReceiver,
                    sectorReceiver: this.sectorReceiver,
                    street1Receiver: this.street1Receiver,
                    street2Receiver: this.street2Receiver,
                    provinceReceiver: this.provinceReceiver,
                    cantonIdReceiver: this.cityReceiver.canton_id,
                    tlfReceiver: this.phoneNewPerson,
                    parroquiaIdReceiver: typeof this.cityReceiver=='object' ? this.cityReceiver.parroquia_id : this.states.find(e => e.parroquia == this.cityReceiver).parroquia_id,
                    cityReceiver: typeof this.cityReceiver=='object' ? this.cityReceiver.parroquia : this.cityReceiver,
                    referenceReceiver: this.referenceReceiver,
                    quoteId
                }
            }).then(res => {
                
                if(res.data.partyId != null){

                    this.persons.push({
                        party_id: res.data.partyId,
                        name: this.firstNameReceiver+' '+this.lastNameReceiver
                    })

                    this.personReceiver = res.data.partyId
                    this.newPersonReceiving=false
                    this.setDataPerson()

                }

                if(this.newPersonReceiving){

                    this.directionsClient.unshift({

                    })

                    this.setDirectionInputs()
                    
                }


                this.alertNotification({
                    param:{
                        html : res.data.msg,
                    }
                })

                this.setLoadingBtn2()
            }).catch(res => {
                console.error(res)
                this.setLoadingBtn2()
            })

        },

        getDataAutocomplete(url,input){

            return new Promise(resolve=>{

                this.setUrl(`geo/${url}`)
                this.requestApi({
                    method: 'GET',
                    data:{
                        tenantId: process.env.VUE_APP_TENANT
                    } 
                }).then(res => {

                    if(input === 'provinces'){
                        this.provinces= res.data.detail
                    }else if(input === 'states'){
                        this.states= res.data.detail
                    }else{
                        this.sectors = res.data.detail
                        this.autoCompleteSector = res.data.detail.length
                    }

                    resolve()
                })

            })

        },

        setDataPerson(){

            this.overlayReceiver=true
            this.setUrl(`buscar-cliente`);
            this.requestApi({
                method: 'GET',
                data: {
                    partyId : this.personReceiver
                }
            }).then(async res=>{
               
                if(res.data._embedded.buscar_cliente.length){

                    const {
                        first_name,
                        last_name, 
                        phones, 
                        directions, 
                    } = res.data._embedded.buscar_cliente[0]                  

                    this.firstNameReceiver = first_name
                    this.lastNameReceiver = last_name
                    this.directionsClient = directions
                    this.phonesReceiver = phones

                    if(phones.length)
                        this.contactMechIdPhoneReceiver = phones[0].contact_mech_id
                    
                    if(directions.length){
                        
                        this.provinceReceiver= directions[0].geo_id

                        await this.getDataAutocomplete(`${this.provinceReceiver}/parroquias-provincia`,'states')
                        this.cityReceiver = directions[0].city

                        let objState = this.states.find(e => e.parroquia == this.cityReceiver)
                        
                        if(typeof objState != 'undefined'){
                            await this.getDataAutocomplete(`${this.states.find(e => e.parroquia == this.cityReceiver).canton_id}/sectores-canton`,'sector')
                            this.sectorReceiver= isNaN(parseInt(directions[0].sector)) ?  directions[0].sector : parseInt(directions[0].sector)
                        }

                        this.directionReceiver = directions[0].contact_mech_id
                        this.referenceReceiver = directions[0].observaciones
                        this.street1Receiver = directions[0].address1
                        this.street2Receiver = directions[0].calle_secundaria
                        
                    }
                    this.setDirectionInputs()
                    this.overlayReceiver=false

                }else{

                }
                
            })

        },

        addPhone(person){

            this.partyIdPhone = person == 'client' ? this.user.party_id : this.personReceiver
            this.personPhone = person
            this.dialogNewPhone=true
            
        },
        
        storeNewPhone(){

            if(!this.$refs.form_new_phone.validate())
                return false

            this.setUrl(`buscar-cliente/${this.partyIdPhone}`);
            this.requestApi({
                method: 'PATCH',
                data: {
                    phone : this.newPhone
                }
            }).then(res => {

                this.alertNotification({
                    param:{
                        html : res.data.detail.msg
                        
                    }
                })

                if(this.personPhone == 'receiver'){

                    this.phonesReceiver.push({
                        contact_mech_id: res.data.detail.cmIdPhone,
                        phone: this.newPhone
                    })

                    this.contactMechIdPhoneReceiver = res.data.detail.cmIdPhone

                }else{

                    this.phones.push({
                        contact_mech_id: res.data.detail.cmIdPhone,
                        phone: this.newPhone
                    })

                    this.contactMechIdPhone = res.data.detail.cmIdPhone
                }

                this.newPhone=null
                this.dialogNewPhone = false
                
            })

        },

        closePhoneDialog(){

            this.dialogNewPhone=false
            this.newPhone=null
        },

        goToPlaceToPay(){

            if (!this.$refs.form_new_purchase.validate()) 
                return

            this.overlayReceiver=true
            this.setUrl('place-to-pay');
            
            this.requestApi({
                method: 'GET',
                data: {
                    partyId : this.user.party_id
                }
            }).then(res => {

                this.overlayReceiver=false
               
                if(res.data.total_items){

                    let html =''

                    res.data._embedded.place_to_pay.forEach(obj => {

                        html+= `<div class='col-12'> 
                            <div class="py-0">
                                <div class="row">
                                    <div class='col-6' style='padding-bottom:0px'><b>REFERENCIA: ${obj.referece_id_place_to_pay}</b></div>
                                    <div class='col-6  text-right' style='padding-bottom:0px'><b>TOTAL ${obj.total}</b></div>
                                </div>
                            </div>
                        </div>`

                    })

                    Vue.swal({
                        title: '<b style="color:#f6921e">TIENE PAGOS DE TRANSACCIONES PENDIENTES</b>',
                        html,
                        icon: "warning",
                        toast: false,
                        grow: false,
                        position: "center",
                        showCancelButton: true,
                        cancelButtonText:'Cancelar',
                        confirmButtonText: 'Continuar!',
                        confirmButtonColor: "#50c995"
                    }).then(res=>{

                        if(res.isConfirmed)
                            this.createSessionPlaceToPay()
                        
                    })

                }else{

                    this.createSessionPlaceToPay()

                }

                console.log(res.data.total_items)
            
            }).catch(err=>{
                this.overlayReceiver=false
            })

        },

        createSessionPlaceToPay(){
            
            try{
            
                let quoteId = localStorage.getItem('quote_id')
                this.overlayReceiver = true
                let valNonce =''
                let paymentId = ''
                const now = moment().format()
                const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
                const charactersLength = characters.length

                for ( let i = 0; i < 30; i++ ) 
                    valNonce += characters.charAt(Math.floor(Math.random() * charactersLength))

                for ( let i = 0; i < 10; i++ ) 
                    paymentId += characters.charAt(Math.floor(Math.random() * charactersLength))

                let documentTypes = [
                    {cod : 'CEDULA' ,name: 'CI'},
                    {cod : 'RUC' ,name:'RUC'},
                    {cod: 'PASAPORTE' ,name:'PPN'}
                ]

                let ip = '127.0.0.1'

                fetch('https://api.ipify.org/').then(r => r.text()).then(res => { ip = res })
            
                let options ={
                    method: 'POST',
                    url: this.endPointPlaceToPay,
                    headers: {'Content-Type': 'application/json'},
                    data: {
                        "locale": "es_EC",
                        "auth": {
                            "login": this.loginPlaceToPay,
                            "tranKey": btoa(sha1(valNonce+now+this.accessKeyPlaceToPay,{asString: true})),
                            "nonce": btoa(valNonce),
                            "seed": now
                        },
                        "buyer": {
                            "document": this.identification,
                            "documentType": documentTypes.find(e => e.cod == this.identificationType).name,
                            "name": this.firstName,
                            "surname": this.lastName,
                            "email": this.email,
                            "mobile": this.phones.find(e => e.contact_mech_id = this.contactMechIdPhone).phone
                        },
                        "payment": {
                            "reference": `${process.env.VUE_APP_TENANT}-${paymentId.toUpperCase()}-${quoteId}`,
                            "description": "Pago de cotización",
                            "amount": {
                                "currency": "USD",
                                "total": this.total,
                                "taxes": [
                                    {
                                        "kind": "valueAddedTax",
                                        "amount": this.taxes,
                                        "base": this.taxes > 0 ? this.subTotalWithImp : 0
                                    }
                                ],
                                "details":null
                            },
                            "items": [],
                            "subscribe": false,
                            "allowPartial": false,
                        },
                        "expiration": moment().add(20, 'minutes').format(),
                        "returnUrl": location.origin+"/pago-place-to-pay",
                        "ipAddress": ip,
                        "userAgent": "PlacetoPay Sandbox", // NAVEGADOR QUE USA LA PERSONA
                        "skipResult": false,
                    }
                } 
            
                if(this.deliveryType == 'delivery'){
                   
                    options.data.payment.shipping={
                        "name": this.firstNameReceiver,
                        "surname":this.lastNameReceiver,
                        "mobile": this.phonesReceiver.find(e => e.contact_mech_id == this.contactMechIdPhoneReceiver).phone,
                        "address": {
                            "street": this.street1Receiver+' '+this.street2Receiver,
                            "city":this.cityReceiver,
                            "state": this.provinces.find(e => e.geo_id == this.provinceReceiver).geo_name,
                            "country": "Ecuador"
                        }
                    }

                }

                let selectedProducts = JSON.parse(localStorage.getItem('shoppingCar'))

                for(let p of selectedProducts){

                    let subTotalPrice = parseFloat(p.price)

                    if(parseFloat(p.tax_value) > 0)
                        subTotalPrice = parseFloat((p.price - p.valor_descuento )/ (1+(p.tax_value/100)))

                    let tax_value = subTotalPrice * (p.tax_value/100)

                    options.data.payment.items.push({
                        "sku": p.product_id,
                        "name": p.internal_name,
                        "qty": p.quantity.toString(),
                        "price": parseFloat(subTotalPrice.toFixed(2)),
                        "tax": parseFloat(tax_value.toFixed(2))
                    })

                }

                axios.request(options).then(res => {
                   
                    if(res.status == 200 && typeof res.data.status != 'undefined' && res.data.status.status == 'OK'){

                        P.init(res.data.processUrl, { opacity: 0.4 })
                        this.requestIdPlaceToPay = res.data.requestId
                        this.continueQuote(`${process.env.VUE_APP_TENANT}-${paymentId.toUpperCase()}-${quoteId}`)

                    }
                        
                    this.overlayReceiver =false
                    console.log('respuesta placetopay',res)

                }).catch(function (error) {

                    console.error(error)

                }).then(()=>{
                    
                    P.on('response', data => { this.verifyTransactionPlacetopay(data) })

                })
            }catch(err) {
                console.log(err)
            }

        },

        calculateTotals(){

            let selectedProducts = JSON.parse(localStorage.getItem('shoppingCar'))
            let subTotal = 0
            let taxes = 0
            let total = 0
            let subTotalWithImp = 0
           
            selectedProducts.forEach(obj =>{
                  
                let tax = 0
                let subTotalPrice= 0

                if(parseFloat(obj.tax_value) > 0){

                    subTotalPrice = ( obj.price - obj.valor_descuento ) / (1+(obj.tax_value/100))
                    
                    tax = ( subTotalPrice * (obj.tax_value/100) ) * obj.quantity  
                    subTotalWithImp+= subTotalPrice              
                    
                }else{

                    subTotalPrice = obj.price - obj.valor_descuento
                }
                   
                this.subTotalWithImp = subTotalWithImp
                subTotal += parseFloat((subTotalPrice*obj.quantity))
                taxes+= parseFloat(tax)
                total += parseFloat((obj.price - obj.valor_descuento) *obj.quantity)

            })
           
            this.subTotal = subTotal
            this.taxes = taxes
            this.total = total+this.priceShipment

        },

        onMapClick(event){
            console.log(event)
            /* this.makers=[]
            this.objGeoCoding.provider.search({query:`${event.latlng.lat},${event.latlng.lng}`})
            .then(res => {
                this.makers.push({
                    latLng: [event.latlng.lat,event.latlng.lng],
                    label: res[0].raw.formatted_address
                })
            }) */
        },

        onDragEnd(point){
                console.log(point)

            this.maker.latLng = [point.target._latlng.lat, point.target._latlng.lng]

            this.selectShippingMethod()
              
            
        },

        selectShippingMethod(){
           
            let geohash = Geohash.encode(this.maker.latLng[0],this.maker.latLng[1], 9);
            this.priceShipment=0

            this.shippingMethods.forEach(sm => {

                let availableGeoHash = sm.geohashs.find(e => { return e.geohash == geohash.substring(0, 5) || e.geohash == geohash.substring(0, 6) || e.geohash == geohash.substring(0, 7) })

                if(typeof availableGeoHash != 'undefined'){

                    this.priceShipment = parseFloat(sm.price);
                    this.shipmentMethodId = sm.shipmentMethodId
                    this.carrierPartyId = sm.carrierPartyId
                    return

                }
              
            })
            this.calculateTotals()

        },

        changeDeliveryType(){

            this.iconTypeDelivey = this.deliveryType == 'delivery' ? 'mdi mdi-truck' : 'mdi mdi-store'

            if(this.deliveryType == 'pickup'){
                this.priceShipment = 0
                this.shipmentMethodId='NO_SHIPPING'
                this.carrierPartyId=null
                this.calculateTotals()
            }  

        },

        verifyTransactionPlacetopay(data){

            this.statusPaymentPlaceToPay= data.status.status

            this.updateStatusQuote(data)
            .then(()=>{

                if(data.status.status == "APPROVED"){

                    let html = `<div class='col-12'> 
                        <div class="py-0">
                            <div style='padding: 10px;background: #50c995;color: white;'>
                                <p><b>REFERENCIA. ${data.reference} </b></p>
                            </div>
                            <div class="row">
                                <div class='col-6' style='padding-bottom:0px'><b>SUBTOTAL</b></div>
                                <div class='col-6  text-right' style='padding-bottom:0px'><b>$${this.subTotal.toFixed(2)}</b></div>
                            </div>
                            <div class='row'>
                                <div class='col-6' style='padding-bottom:0px'><b>IVA</b></div>
                                <div class='col-6  text-right' style='padding-bottom:0px'><b>$${this.taxes.toFixed(2)}</b></div>
                            </div>
                            <div class="row">
                                <div class='col-6' style='padding-bottom:0px'><b>ENVÍO</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.priceShipment.toFixed(2)}</b></div>
                            </div>
                            <div class='row'>
                                <div class='col-6' style='padding-bottom:0px'><b>TOTAL</b></div>
                                <div class='col-6  text-right' style='padding-bottom:0px'><b>$${this.total.toFixed(2)}</b></div>
                            </div>
                        </div>
                    </div>`

                    Vue.swal({
                        title: 'TRANSACCIÓN "APROBADA"',
                        html,
                        icon: "success",
                        confirmButtonColor: "#50c995",
                        toast: false,
                        grow: false,
                        position: "center",
                        confirmButtonText: "Continuar"
                    }).then(res=>{

                        if(res.isConfirmed)
                            this.$router.push('/') 

                        this.deleteShoppingCar()

                    })

                }else if(data.status.status == "REJECTED"){

                    let html = `<div class='col-12'> 
                        <div class="py-0">
                            <div style='padding: 10px;background: #d60400;color: white;'>
                                <p><b>REFERENCIA. ${data.reference} </b></p>
                            </div>
                            <div class="row">
                                <div class='col-6' style='padding-bottom:0px'><b>SUBTOTAL</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.subTotal.toFixed(2)}</b></div>
                            </div>
                            <div class='row'>
                                <div class='col-6' style='padding-bottom:0px'><b>IVA</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.taxes.toFixed(2)}</b></div>
                            </div>
                            <div class="row">
                                <div class='col-6' style='padding-bottom:0px'><b>ENVÍO</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.priceShipment.toFixed(2)}</b></div>
                            </div>
                            <div class='row'>
                                <div class='col-6' style='padding-bottom:0px'><b>TOTAL</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.total.toFixed(2)}</b></div>
                            </div>
                        </div>
                    </div>`

                    Vue.swal( {
                        title:  '<b style="color:#d60400">TRANSACCIÓN "RECHAZADA"</b>',
                        html,
                        icon: "error",
                        confirmButtonColor: "#d60400",
                        toast: false,
                        grow: false,
                        position: "center",
                        confirmButtonText: "Cerrar"
                    })
                    
                }else if(data.status.status == "PENDING"){

                    let html = `<div class='col-12'> 
                        <div class="py-0">
                            <div style='padding: 10px;background: #f6921e;color: white;'>
                                <p><b>REFERENCIA. ${data.reference} </b></p>
                            </div>
                            <div class="row">
                                <div class='col-6' style='padding-bottom:0px'><b>SUBTOTAL</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.subTotal.toFixed(2)}</b></div>
                            </div>
                            <div class='row'>
                                <div class='col-6' style='padding-bottom:0px'><b>IVA</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.taxes.toFixed(2)}</b></div>
                            </div>
                            <div class="row">
                                <div class='col-6' style='padding-bottom:0px'><b>ENVÍO</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.priceShipment.toFixed(2)}</b></div>
                            </div>
                            <div class='row'>
                                <div class='col-6' style='padding-bottom:0px'><b>TOTAL</b></div>
                                <div class='col-6 text-right' style='padding-bottom:0px'><b>$${this.total.toFixed(2)}</b></div>
                            </div>
                        </div>
                    </div>`

                    Vue.swal( {
                        title:  '<b style="color:#f6921e">TRANSACCIÓN "PENDIENTE"</b>',
                        html,
                        icon: "warning",
                        confirmButtonColor: "#f6921e",
                        toast: false,
                        grow: false,
                        position: "center",
                        confirmButtonText: "Cerrar"
                    }).then(res=>{

                        if(res.isConfirmed)
                            this.$router.push('/') 

                        this.deleteShoppingCar()

                    })

                } 

            })

        },

        deleteShoppingCar(){

            localStorage.setItem("shoppingCar", JSON.stringify([]))
            localStorage.removeItem('quote_id') 
            this.requestIdPlaceToPay=null
            this.itemShoppingCar([])
            this.calculateTotals()
            this.deleteSelectedProducts()

        },

        updateStatusQuote(data){

            return new Promise((resolve, rejected) =>{

                this.overlayReceiver=true
                this.setUrl("place-to-pay/"+localStorage.getItem('quote_id'))
                this.requestApi({
                    method: 'PUT',
                    data: data
                })
                .then(res=>{

                    console.log(res)
                    this.overlayReceiver=false
                    resolve(res)

                }).catch(err=>{
                    rejected(err)
                    this.overlayReceiver=false
                })


            })

        },

        showhideMap(){

            this.showMap = !this.showMap
            this.$nextTick(() => {
                this.$refs.myMap.mapObject.invalidateSize()            
            })
        },

        applyCoupons(){

            if(this.coupon == '' || this.coupon == null){
                this.errorsCoupon = 'Debe ingresar un cuppón a aplicar'
                return false
            }

            this.errorsCoupon = null
            
            this.setUrl(`completar-cotizacion-ecommerce/${this.coupon}`)

            this.requestApi({
                method: 'PATCH',
                data: {
                    data:{
                        quoteId: localStorage.getItem('quote_id')
                    }
                }
            }).then(res=>{

                console.log(res)
                const { data, respp } = res

                if(data.success){

                    this.succCoupon = data.success
                    this.successCoupon= data.msg 
                    this.errorsCoupon= null
                    this.errorCoupon=false
                    this.overlayReceiver= true

                    this.updateQuoteItems({
                        action:'modify',
                        quoteId: localStorage.getItem('quote_id')
                    })
                    .then(res =>{

                        this.deleteSelectedProducts()

                        res.data.detail.quoteItems.forEach(item => {
                            
                            this.setSelectedProducts({
                                product_id: item.product_id,
                                images: item.images,
                                price: parseFloat(item.price),
                                quantity: parseFloat(item.quantity),
                                brand_name : item.brand_name,
                                internal_name : item.internal_name,
                                tax_value : parseFloat(item.tax_value),
                                psicotropico: item.psicotropico,
                                quoteItemSeqId: item.quote_item_seq_id,
                                inventory: item.inventory,
                                valor_descuento: isNaN(parseFloat(item.valor_descuento)) ? 0 : parseFloat(item.valor_descuento),
                                is_promo: isNaN(parseFloat(item.is_promo)) ? 0 : parseFloat(item.is_promo)
                            })

                        })  

                        this.itemShoppingCar(this.selectedProducts)

                        this.calculateTotals()
                        this.overlayReceiver= false

                    })

                }else{

                    this.succCoupon = false
                    this.successCoupon= null
                    this.errorsCoupon = data.msg 
                    this.errorCoupon= !data.success

                }
                

            })

        }

    },
    created(){

        this.identification = this.user.identification
        this.searchClient()
        this.getBankAccountData()
        this.getDataAutocomplete('ECU/provincias-pais','provinces')
        this.calculateTotals()
        delete Icon.Default.prototype._getIconUrl;
        Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        })

    },
    mounted(){
        
        
    }
}
</script>

<style scope>
    form fieldset {
        border: 2px solid #ffaa45 !important;
    }
    .form-text-area > div > div > fieldset {
        border: 2px solid #c9c7c7 !important;
    }

    .swal2-title {
        color: #50c995;
        font-family: "Asap";
        font-size: 23px;
    }

    .swal2-html-container {
        font-family: "Asap";
        color: "#c9c7c7";
    }

    .swal2-confirm {
        font-family: "Asap";
    }

    .swal2-success-ring,
    .swal2-success-line-long,
    .swal2-success-line-tip,
    .swal2-icon,
    .swal2-success {
        color: #50c995 !important ;
    }

    form.form_billing_data fieldset{
        border-radius: 20px;
    }

    .v-menu__content{
        z-index:9999!important
    }

    .v-overlay--active{
        z-index: 9999!important;
    }
    

    @media (max-width: 1280px) and (min-width: 960px) {
        .col-md1-5 {
            flex: 0 0 14.3333333333% !important;
            max-width: 14.3333333333% !important;
        }
    }
</style>
